import React from "react";
import { Link } from "react-router-dom";

export default function WalletPage() {
  return (
    <main className="max-w-[860px] mx-auto px-6 py-20">
      <div className="wk-eyebrow mb-5">Pack de prueba</div>
      <h1 className="text-[42px] lg:text-[56px] font-extrabold tracking-hero leading-[1.05]" style={{ color: "#1E1924" }}>
        Empieza con dos conversaciones reales.
      </h1>
      <p className="mt-6 text-[16px] leading-[1.6] max-w-prose-tight" style={{ color: "#70667A" }}>
        $22 · pago único · 2 sesiones de 30 min + 1 informe tras cada sesión.
      </p>
      <Link className="wk-btn wk-btn-primary mt-9" to="/reservar" data-testid="wallet-submit-btn">
        Reservar mi primera sesión · $22
      </Link>
    </main>
  );
}
